export default {
    SOLICITADO: 1,
    AGENDADO: 2,
    REALIZADO: 3,
    FALTA: 4,
    CANCELADO: 5,
    REAGENDADO: 6,
}